import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { IMAGES } from "@/site";
import { PageHero, Section, CTABand } from "@/components/ui-blocks/Blocks";

const FAQS = [
  { q: "Is CLB Solution open now?", a: "CLB Solution LLC is currently preparing for launch. Services, programs, and digital tools are being developed and may become available in phases." },
  { q: "Who does CLB Solution serve?", a: "CLB Solution is being built to serve individual trainees, current drivers, returning drivers, school districts, transportation departments, and contractors." },
  { q: "Where is CLB Solution based?", a: "CLB Solution is Delaware-based with future expansion planned." },
  { q: "Does CLB Solution offer pre-trip inspection training?", a: "Yes. Pre-trip inspection training is one of the main focus areas of CLB Solution." },
  { q: "Does CLB Solution offer refresher training?", a: "Yes. Refresher training is planned for drivers who need to review procedures, rebuild confidence, or sharpen safety habits." },
  { q: "Does CLB Solution offer corrective or remedial training?", a: "Yes. Corrective training is planned for drivers needing support after incidents, unsafe habits, or preventable safety concerns." },
  { q: "Does CLB Solution offer behind-the-wheel training?", a: "Behind-the-wheel readiness support is planned as part of future training development." },
  { q: "Is the CLB Solution Pretrip Guide available now?", a: "Not yet. The CLB Solution Pretrip Guide is currently in development and will be announced when ready." },
  { q: "Does CLB Solution work with school districts?", a: "CLB Solution is being built to support school districts, transportation departments, and contractors through training support, safety education, and future workforce development solutions." },
  { q: "Does CLB Solution list pricing online?", a: "No. Pricing and service availability may vary based on training needs, program structure, and organizational support. Contact CLB Solution directly for information." },
  { q: "How do I contact CLB Solution?", a: "Email: clbsolutionllc@gmail.com" },
];

export default function Faq() {
  return (
    <>
      <PageHero
        testid="faq-hero"
        eyebrow="FAQ"
        title="Frequently asked questions."
        description="Quick answers about CLB Solution training, services, and the upcoming Pretrip Guide app."
        image={IMAGES.services}
      />

      <Section testid="faq-list">
        <div className="border border-white/10 bg-[#0c0c0e] p-2 md:p-4">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b border-white/10 last:border-b-0">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="px-4 py-6 text-left font-display text-lg md:text-xl font-bold uppercase tracking-tight hover:text-[#FFCC00] hover:no-underline"
                >
                  <span className="flex items-start gap-4 pr-4">
                    <span className="font-mono text-[11px] text-[#FFCC00] mt-1 shrink-0">{String(i + 1).padStart(2, "0")}</span>
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="px-4 pb-6 pl-12 text-white/70 text-base leading-relaxed"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </Section>

      <CTABand />
    </>
  );
}
